import React, { Component } from 'react'
import styles from './school-files-filter.styles'
import injectSheet from 'react-jss'
import Cell from './cell/cell'
import FormInput from 'pobble-components/dist/form-elements/form-input'
import FormSelect from 'pobble-components/dist/form-elements/form-select'
import Button from 'pobble-components/dist/button'
import debounce from 'lodash/debounce'
import every from 'lodash/every'
import isEmpty from 'lodash/isEmpty'

const DEBOUNCE_DELAY = 500

class SchoolFilesFilter extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: props.title,
      benchmarked: props.benchmarked,
      judgement: props.judgement,
      moderationType: props.moderationType,
      owner: props.owner,
      yearGroup: props.yearGroup,
      yearGroups: []
    }
  }
  componentDidMount() {
    this.props
      .onPullAgeGroups()
      .then(res => this.setState({ yearGroups: res.data.year_groups }))
  }

  areFiltersEmpty = () => every(this.state, isEmpty)
  onClearFilters = () => {
    const filters = {
      title: '',
      benchmarked: false,
      judgement: '',
      moderationType: '',
      owner: '',
      yearGroup: false
    }
    this.setState(filters)
    this.props.onFiltersUpdate(filters)
  }
  debouncedFiltersUpdate = debounce(
    () => this.props.onFiltersUpdate(this.state),
    DEBOUNCE_DELAY
  )
  handleChange = (value, key, callback) => {
    this.setState({ [key]: value })
    this.debouncedFiltersUpdate()
  }
  render() {
    const {
      title,
      benchmarked,
      judgement,
      moderationType,
      owner,
      yearGroup
    } = this.state
    return (
      <table>
        <tbody>
          <tr>
            <Cell>
              <FormInput
                value={title}
                placeholder="Search for a file"
                onChange={e =>
                  this.handleChange(e.target.value, 'title', 'onTitleChange')
                }
              />
            </Cell>
            <Cell>
              <FormInput
                value={owner}
                placeholder="Teacher name"
                onChange={e =>
                  this.handleChange(e.target.value, 'owner', 'onOwnerChange')
                }
              />
            </Cell>
            <Cell>
              <FormSelect
                value={benchmarked}
                onChange={e =>
                  this.handleChange(
                    e.target.value,
                    'benchmarked',
                    'onBenchmarkedChange'
                  )
                }>
                <option value="false">All files</option>
                <option value="true">Exemplars only</option>
              </FormSelect>
            </Cell>
            <Cell>
              <FormSelect
                value={yearGroup}
                onChange={e =>
                  this.handleChange(
                    e.target.value,
                    'yearGroup',
                    'onYearGroupChange'
                  )
                }>
                <option value="">Ages</option>
                {this.state.yearGroups.map(yearGroup => (
                  <option value={yearGroup.id} key={yearGroup.id}>
                    {yearGroup.title}
                  </option>
                ))}
              </FormSelect>
            </Cell>

            <Cell>
              <FormSelect
                value={judgement}
                onChange={e =>
                  this.handleChange(
                    e.target.value,
                    'judgement',
                    'onJudgementChange'
                  )
                }>
                <option value="">All judgements</option>
                <option value="working_towards_the_expected_standard">
                  Working towards the expected standard
                </option>
                <option value="working_at_the_expected_standard">
                  Working at the expected standard
                </option>
                <option value="greater_depth_within_the_expected_standard">
                  Greater depth within the expected standard
                </option>
              </FormSelect>
            </Cell>
            <Cell>
              <FormSelect
                value={moderationType}
                onChange={e =>
                  this.handleChange(
                    e.target.value,
                    'moderationType',
                    'onModerationTypeChange'
                  )
                }>
                <option value="">All types</option>
                <option value="in_school_moderation">
                  In school moderation
                </option>
                <option value="cross_school_moderation">
                  Cross school moderation
                </option>
                <option value="statutory_moderation">
                  Statutory moderation
                </option>
                <option value="external_non_statutory_moderation">
                  External non statutory moderation
                </option>
              </FormSelect>
            </Cell>
            <Cell cellProps={{ colSpan: 6 }}>
              <Button
                disabled={this.areFiltersEmpty()}
                action={this.onClearFilters}
                tall
                wide
                secondary>
                Clear
              </Button>
            </Cell>
          </tr>
        </tbody>
      </table>
    )
  }
}

export default injectSheet(styles)(SchoolFilesFilter)
